module.exports = __webpack_public_path__ + "img/abovekneecircumference.4ecdf442.jpeg";